/** @format */

import React, { Fragment } from 'react';
import Grid from '@material-ui/core/Grid';
import DocumentInfoContainer from 'src/ui/features/Documents/containers/DocumentInfoContainer';
import HistoryDisplayContainer from 'src/ui/library/HistoryDisplay';
import classNames from 'classnames';

export const DocumentsDetailPres = props => {
  const renderSubheader = () => {
    const { documentDetail, isEYPro } = props;

    if (!(documentDetail && documentDetail.documentInformation)) return;

    let fields = [
      {
        name: 'Document ID',
        value: documentDetail.documentInformation.documentId,
      },
      {
        name: 'Document Type',
        value: documentDetail.documentInformation.documentType,
      },
      {
        name: 'Document Name',
        value: documentDetail.documentInformation.documentName,
      },
    ];

    //extra field for EY Pro
    if (isEYPro) fields = [...fields, { name: 'Client', value: documentDetail.documentInformation.client }];

    fields = [...fields, 
      { 
        name: 'Additional Comments', 
        value: documentDetail.documentInformation.additionalComments 
      }
    ];

    return fields.map((item, index) => {
      return (
        <div className="document-details-subheader-item" key={item + '-' + index * Math.random()}>
          <label className="document-details-subheader-label">{item.name}</label>
          <div title={item.value} className={classNames({
                ["document-details-subheader-title"]: true,
                ["document-details-subheader-title-additional"]: item.name === 'Additional Comments'
              })}>{item.value}</div>
        </div>
      );
    });
  };

  return (
    <Fragment>
      <Grid item xs={12}>
        <Grid container className="documents-filter-grid">
          <Grid container className="caps-fields first-info-cell ">
            <Grid item xs={12}>
              <HistoryDisplayContainer history={props.history} />
            </Grid>
            <div className="document-details-subheader">{renderSubheader()}</div>
          </Grid>
        </Grid>
      </Grid>

      <DocumentInfoContainer match={props.match} history={props.history} />
    </Fragment>
  );
};

export default DocumentsDetailPres;



// WEBPACK FOOTER //
// ./src/ui/features/Documents/presentational/DocumentsDetailPres.js